import { render, staticRenderFns } from "./spread-center-inner-bv.vue?vue&type=template&id=e0c54474"
import script from "./spread-center-inner-bv.vue?vue&type=script&lang=js"
export * from "./spread-center-inner-bv.vue?vue&type=script&lang=js"
import style0 from "./spread-center-inner-bv.vue?vue&type=style&index=0&id=e0c54474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports